import script from "./ParcelDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ParcelDetails.vue?vue&type=script&setup=true&lang=js"

import "./ParcelDetails.vue?vue&type=style&index=0&id=36c92556&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36c92556"]])

export default __exports__